window.Vue = require('vue');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import App from './components/App';

const app = new Vue({
    el: '#qr-reader',
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./themes/b2b/dev/js/qr/app.js